// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { FaultTimerAction } from "./fault-timer-action";

/**
 * Frontend-specific state snapshot.
 */
export class FrontendSnapshot implements flatbuffers.IUnpackableObject<FrontendSnapshotT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FrontendSnapshot {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFrontendSnapshot(
    bb: flatbuffers.ByteBuffer,
    obj?: FrontendSnapshot,
  ): FrontendSnapshot {
    return (obj || new FrontendSnapshot()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsFrontendSnapshot(
    bb: flatbuffers.ByteBuffer,
    obj?: FrontendSnapshot,
  ): FrontendSnapshot {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FrontendSnapshot()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  batchSize(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  dedupRatio(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
  }

  decodeFailures(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  pendingDispatches(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  faultTimerCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  faultTimerAction(): FaultTimerAction {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : FaultTimerAction.Start;
  }

  debounceMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  rafFlushedCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  static startFrontendSnapshot(builder: flatbuffers.Builder) {
    builder.startObject(8);
  }

  static addBatchSize(builder: flatbuffers.Builder, batchSize: number) {
    builder.addFieldInt32(0, batchSize, 0);
  }

  static addDedupRatio(builder: flatbuffers.Builder, dedupRatio: number) {
    builder.addFieldFloat32(1, dedupRatio, 0.0);
  }

  static addDecodeFailures(builder: flatbuffers.Builder, decodeFailures: number) {
    builder.addFieldInt32(2, decodeFailures, 0);
  }

  static addPendingDispatches(builder: flatbuffers.Builder, pendingDispatches: number) {
    builder.addFieldInt32(3, pendingDispatches, 0);
  }

  static addFaultTimerCount(builder: flatbuffers.Builder, faultTimerCount: number) {
    builder.addFieldInt32(4, faultTimerCount, 0);
  }

  static addFaultTimerAction(builder: flatbuffers.Builder, faultTimerAction: FaultTimerAction) {
    builder.addFieldInt8(5, faultTimerAction, FaultTimerAction.Start);
  }

  static addDebounceMs(builder: flatbuffers.Builder, debounceMs: number) {
    builder.addFieldInt32(6, debounceMs, 0);
  }

  static addRafFlushedCount(builder: flatbuffers.Builder, rafFlushedCount: number) {
    builder.addFieldInt32(7, rafFlushedCount, 0);
  }

  static endFrontendSnapshot(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createFrontendSnapshot(
    builder: flatbuffers.Builder,
    batchSize: number,
    dedupRatio: number,
    decodeFailures: number,
    pendingDispatches: number,
    faultTimerCount: number,
    faultTimerAction: FaultTimerAction,
    debounceMs: number,
    rafFlushedCount: number,
  ): flatbuffers.Offset {
    FrontendSnapshot.startFrontendSnapshot(builder);
    FrontendSnapshot.addBatchSize(builder, batchSize);
    FrontendSnapshot.addDedupRatio(builder, dedupRatio);
    FrontendSnapshot.addDecodeFailures(builder, decodeFailures);
    FrontendSnapshot.addPendingDispatches(builder, pendingDispatches);
    FrontendSnapshot.addFaultTimerCount(builder, faultTimerCount);
    FrontendSnapshot.addFaultTimerAction(builder, faultTimerAction);
    FrontendSnapshot.addDebounceMs(builder, debounceMs);
    FrontendSnapshot.addRafFlushedCount(builder, rafFlushedCount);
    return FrontendSnapshot.endFrontendSnapshot(builder);
  }

  unpack(): FrontendSnapshotT {
    return new FrontendSnapshotT(
      this.batchSize(),
      this.dedupRatio(),
      this.decodeFailures(),
      this.pendingDispatches(),
      this.faultTimerCount(),
      this.faultTimerAction(),
      this.debounceMs(),
      this.rafFlushedCount(),
    );
  }

  unpackTo(_o: FrontendSnapshotT): void {
    _o.batchSize = this.batchSize();
    _o.dedupRatio = this.dedupRatio();
    _o.decodeFailures = this.decodeFailures();
    _o.pendingDispatches = this.pendingDispatches();
    _o.faultTimerCount = this.faultTimerCount();
    _o.faultTimerAction = this.faultTimerAction();
    _o.debounceMs = this.debounceMs();
    _o.rafFlushedCount = this.rafFlushedCount();
  }

  unpackFields(...fields: string[]): FrontendSnapshotT {
    const t = new FrontendSnapshotT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("batch_size")) {
      t.batchSize = this.batchSize();
    }
    if (fieldSet.has("dedup_ratio")) {
      t.dedupRatio = this.dedupRatio();
    }
    if (fieldSet.has("decode_failures")) {
      t.decodeFailures = this.decodeFailures();
    }
    if (fieldSet.has("pending_dispatches")) {
      t.pendingDispatches = this.pendingDispatches();
    }
    if (fieldSet.has("fault_timer_count")) {
      t.faultTimerCount = this.faultTimerCount();
    }
    if (fieldSet.has("fault_timer_action")) {
      t.faultTimerAction = this.faultTimerAction();
    }
    if (fieldSet.has("debounce_ms")) {
      t.debounceMs = this.debounceMs();
    }
    if (fieldSet.has("raf_flushed_count")) {
      t.rafFlushedCount = this.rafFlushedCount();
    }
    return t;
  }
}

export class FrontendSnapshotT implements flatbuffers.IGeneratedObject {
  constructor(
    public batchSize: number = 0,
    public dedupRatio: number = 0.0,
    public decodeFailures: number = 0,
    public pendingDispatches: number = 0,
    public faultTimerCount: number = 0,
    public faultTimerAction: FaultTimerAction = FaultTimerAction.Start,
    public debounceMs: number = 0,
    public rafFlushedCount: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return FrontendSnapshot.createFrontendSnapshot(
      builder,
      this.batchSize,
      this.dedupRatio,
      this.decodeFailures,
      this.pendingDispatches,
      this.faultTimerCount,
      this.faultTimerAction,
      this.debounceMs,
      this.rafFlushedCount,
    );
  }

  clone(): FrontendSnapshotT {
    const obj = new FrontendSnapshotT();
    obj.batchSize = this.batchSize;
    obj.dedupRatio = this.dedupRatio;
    obj.decodeFailures = this.decodeFailures;
    obj.pendingDispatches = this.pendingDispatches;
    obj.faultTimerCount = this.faultTimerCount;
    obj.faultTimerAction = this.faultTimerAction;
    obj.debounceMs = this.debounceMs;
    obj.rafFlushedCount = this.rafFlushedCount;
    return obj;
  }

  equals(other: FrontendSnapshotT): boolean {
    if (this.batchSize !== other.batchSize) return false;
    if (!Object.is(this.dedupRatio, other.dedupRatio)) return false;
    if (this.decodeFailures !== other.decodeFailures) return false;
    if (this.pendingDispatches !== other.pendingDispatches) return false;
    if (this.faultTimerCount !== other.faultTimerCount) return false;
    if (this.faultTimerAction !== other.faultTimerAction) return false;
    if (this.debounceMs !== other.debounceMs) return false;
    if (this.rafFlushedCount !== other.rafFlushedCount) return false;
    return true;
  }
}

export function verifyFrontendSnapshot(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 4);
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 4);
  } finally {
    verifier.popDepth();
  }
}
